import { get } from "./shared/services/axios-simple";

window.simplyEvent = {};

get(
  `/events.json${
    import.meta.env.VITE_APP_BUILD_VERSION
      ? `?v=${import.meta.env.VITE_APP_BUILD_VERSION}`
      : ""
  }`
)
  .then(({ data }) => {
    window.simplyEvent = data ?? {};
  })
  .catch((error) => {
    console.log(error.toString());
  });
